import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const DividerCard = ({
  header,
  value,
  loading,
  color = 'inherit',
  spacing = true,
}) => (
  <Box
    height="100%"
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    pb={!spacing ? 2 : 0}
  >
    <Typography
      variant="body1"
      color="textSecondary"
      paragraph={spacing}
      style={{ fontWeight: 700 }}
    >
      {header}
    </Typography>
    {!loading ? (
      <Typography variant="h6" color={color} style={{ fontWeight: 800 }}>
        {value}
      </Typography>
    ) : (
      <Skeleton variant="text" height={50} />
    )}
  </Box>
);

DividerCard.propTypes = {
  header: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  loading: PropTypes.bool.isRequired,
  color: PropTypes.oneOf(['inherit', 'secondary']),
  spacing: PropTypes.bool,
};

export default DividerCard;
